import React from 'react';
import {
  ArrowIcon,
  BackFullIcon,
  ButtonComp,
  CalendarIcon,
  CalendarRow,
  CalendarTitleRow,
  Card,
  CardDescriptionLabel,
  CardDescriptionTitle,
  CardRow,
  CardRowForSvg,
  CardsColumns,
  CardSectionColumn,
  CardSectionRow,
  CardSectionTitle,
  CardSeparator,
  Circle,
  ClientHistoryButotn,
  ClientHistoryCard,
  ClientHistoryContent,
  ClientHistoryData,
  ClientHistoryDescription,
  ClientHistoryHeader,
  ClientHistoryFieldRow,
  ClientHistoryFieldLabel,
  ClientHistoryFieldValue,
  Container,
  ContainerCards,
  ContainerIndicator,
  Content,
  EditIcon,
  EditIconSmall,
  GraduationBold,
  GraduationCard,
  GraduationIcons,
  GraduationRow,
  GraduationText,
  Header,
  HeaderBack,
  InterviewCard,
  InterviewContent,
  InterviewDataText,
  InterviewDescription,
  InterviewValue,
  KeyWord,
  KeyWordsArea,
  Language,
  LanguageRow,
  Line,
  LoadingIndicator,
  MatchCard,
  MatchIcon,
  MatchLocal,
  MatchMoney,
  MatchName,
  MatchOccupation,
  ModalSelect,
  ModalSelectContent,
  ModalValue,
  MoneyIcon,
  Name,
  Occupation,
  Photo,
  PinIcon,
  ProfessionalIcons,
  ProfessionalPeriod,
  ProfessionalRow,
  ProfessionalText,
  ProfessionalTextBold,
  ProfissionalCard,
  Responsive,
  Select,
  SelectName,
  SelectsArea,
  SvgRow,
  TrashIcon,
  TrashIconSmall,
} from './styles';

import Button from 'components/button';
import MenuBar from 'components/menu-bar';
import LanguageModal from 'components/modais/language';
import InterviewModal from 'components/modais/interview';
import GraduationModal from 'components/modais/graduation';
import ClientHistoryModal from 'components/modais/client-history';
import ProfissionalExperienceModal from 'components/modais/profissional-experience';

import {
  capitalizeFirstLetter,
  formatarPhone,
  formatCPF,
  limitarString,
  transformarData,
} from 'utils/convert';

import { useNavigate, useParams } from 'react-router-dom';
import { LanguageCRUD } from 'services/requests/language';
import { GraduationCRUD } from 'services/requests/graduation';
import { toast } from 'react-toastify';
import { LoadRow } from '../styles';
import { theme } from 'global/styles';
import { PersonalClientCRUD } from 'services/requests/personal-client';
import { CONST_STATUS } from 'utils/CONSTANTS';
import { ClientHistoryCRUD } from 'services/requests/client_history';
import { InterviewCRUD } from 'services/requests/interview';
import { MatchCRUD } from 'services/requests/matchs';
import { ProfissionalExperienceCRUD } from 'services/requests/profissional-experience';

import typ from './index.d';

const PECrud = new ProfissionalExperienceCRUD();
const matchCrud = new MatchCRUD();
const languageCrud = new LanguageCRUD();
const interviewCrud = new InterviewCRUD();
const graduationCrud = new GraduationCRUD();
const clientHistoryCrud = new ClientHistoryCRUD();
const personalClientCrud = new PersonalClientCRUD();

const KNOWN_FIELD_LABELS = [
  'Prioridade:',
  'Título da vaga:',
  'Razão social:',
  'Controle acionário:',
  'Ramo de atividade:',
  'Nível hierarquico:',
  'Área de atuaçao:',
  'Remuneração:',
  'Faixa etária:',
  'Sexo:',
  'Local de trabalho:',
  'Tipo de contratação:',
  'Perfil:',
  'E-mail:',
  'Encaminhamento:',
  'Benefícios:',
];

const parseStructuredDescription = (description: string) => {
  const hasKnownFields = KNOWN_FIELD_LABELS.filter(label =>
    description.includes(label),
  );
  if (hasKnownFields.length < 3) return null;

  const fields: { label: string; value: string }[] = [];
  let headerText = '';

  const firstFieldIndex = Math.min(
    ...hasKnownFields.map(label => description.indexOf(label)),
  );

  if (firstFieldIndex > 0) {
    headerText = description.substring(0, firstFieldIndex).trim();
  }

  const fieldPositions = hasKnownFields
    .map(label => ({ label, index: description.indexOf(label) }))
    .sort((a, b) => a.index - b.index);

  for (let i = 0; i < fieldPositions.length; i++) {
    const current = fieldPositions[i];
    const nextIndex =
      i + 1 < fieldPositions.length
        ? fieldPositions[i + 1].index
        : description.length;
    const value = description
      .substring(current.index + current.label.length, nextIndex)
      .trim();
    fields.push({
      label: current.label,
      value: value || '-',
    });
  }

  return { headerText, fields };
};

const VisualizatePersonalClient: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Ref
  const currentPage = React.useRef(1);

  // States
  const [loading, setLoading] = React.useState(false);
  const [currentPersonalClient, setCurrentPersonalClient] = React.useState<typ.personalClient>();

  const [languages, setLanguages] = React.useState<typ.languages>();
  const [loadingLanguages, setLoadingLanguages] = React.useState(false);

  const [graduation, setGraduation] = React.useState<typ.graduation[]>();
  const [currentGraduation, setCurrentGraduation] = React.useState<typ.graduation>();
  const [loadingGraduation, setLoadingGraduation] = React.useState(false);

  const [matchs, setMatchs] = React.useState<typ.matchs>();

  const [clientHistory, setClientHistory] = React.useState<typ.clientHistory>();
  const [loadingClientHistory, setLoadingClientHistory] = React.useState(false);

  const [status, setStatus] = React.useState<typ.status>(STATUS[0]);
  const [showStatusModal, setShowStatusModal] = React.useState(false);

  const [interviews, setInterviews] = React.useState<typ.interview[]>();
  const [currentInterview, setCurrentInterview] = React.useState<typ.interview>();
  const [loadingInterview, setLoadingInterview] = React.useState(false);
  
  const [ProfEx, setProfEx] = React.useState<typ.profissionalExperience[]>();
  const [currentProfEx, setCurrentProfEx] = React.useState<typ.profissionalExperience>();
  const [loadingProfEx, setLoadingProfEx] = React.useState(false);

  const [showModalProfEx, setShowModalProfEx] = React.useState(false);
  const [showModalLanguage, setShowModalLanguage] = React.useState(false);
  const [showModalInterview, setShowModalInterview] = React.useState(false);
  const [showModalGraduation, setShowModalGraduation] = React.useState(false);
  const [showModalClientHistory, setShowModalClientHistory] = React.useState(false);

  // Callbacks
  const refreshData = React.useCallback(async (page?: number) => {
    try {
      setLoading(true);
      currentPage.current = page || 1;
      const { data, status, error } = await personalClientCrud.view({
        id: Number(id) || 0,
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        setCurrentPersonalClient(data.PersonalClient[0]);
        let currentStatus: any;
        STATUS.forEach(el => {
          if (el.title === data.PersonalClient[0].status) currentStatus = el;
        });
        if (currentStatus) setStatus(currentStatus);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleUpdateClient = React.useCallback(async (status?: string) => {
    let currentStatus: string = '';

    if (status) {
      if (
        CONST_STATUS.findIndex(
          item => item.label.toLowerCase() === status.toLocaleLowerCase(),
        ) >= 0
      ) {
        currentStatus =
          CONST_STATUS[
            CONST_STATUS.findIndex(
              item => item.label.toLowerCase() === status.toLocaleLowerCase(),
            )
          ].keys;
      } else {
        currentStatus = status;
      }
    }

    const dataApi: any = {};
    if (currentStatus) dataApi.status = currentStatus;

    dataApi.id = id;

    try {
      const {
        data,
        status: Status,
        error,
      } = await personalClientCrud.update(dataApi);

      if (error) throw new Error(error.message.description);
      if (Status === 200 && data) {
        toast('Cliente editado com sucesso.');
      }
    } catch (e) {
      alert(e);
    }
  }, []);


  // Languages
  const getLanguages = React.useCallback(async () => {
    try {
      setLoadingLanguages(true);
      const { data, status, error } = await languageCrud.read({
        isVancacie: false,
        id: Number(id),
      });

      if (error) throw new Error(error.message.description);

      if (status === 200 && data?.Language) {
        setLanguages(data.Language);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingLanguages(false);
    }
  }, []);
  const handleDeleteLanguage = React.useCallback(async (id: number) => {
    try {
      setLoadingLanguages(true);
      const { data, status, error } = await languageCrud.delete({
        id: id,
      });

      if (error) throw new Error(error.message.description);

      if (status === 200) {
        getLanguages();
        toast('Linguagem deletada com sucesso.');
      }
    } catch (e) {
      alert(e);
    }
  }, []);

  // Graduations
  const getGraduations = React.useCallback(async () => {
    try {
      setLoadingGraduation(true);
      const { data, status, error } = await graduationCrud.read({
        isVancacie: false,
        id: Number(id),
      });

      if (error) throw new Error(error.message.description);

      if (status === 200 && data?.Graduation) {
        setGraduation(data.Graduation);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingGraduation(false);
    }
  }, []);
  const handleDeleteGraduations = React.useCallback(async (id: number) => {
    try {
      setLoadingGraduation(true);
      const { data, status, error } = await graduationCrud.delete({
        id: id,
      });

      if (error) throw new Error(error.message.description);

      if (status === 200) {
        getGraduations();
        toast('Formação deletada com sucesso.');
      }
    } catch (e) {
      alert(e);
    }
  }, []);

  // History
  const getClientHistory = React.useCallback(async (page?: number) => {
    try {
      setLoadingClientHistory(true);
      const { data, status, error } = await clientHistoryCrud.read({
        personal_client_id: Number(id),
        page,
        per_page: 20,
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        setClientHistory(data.ClientHistory);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingClientHistory(false);
    }
  }, []);
  const handleDeleteClientHistory = React.useCallback(async (id: number) => {
    try {
      setLoadingClientHistory(true);
      const { data, status, error } = await clientHistoryCrud.delete({
        id: id,
      });

      if (error) throw new Error(error.message.description);

      if (status === 200) {
        getClientHistory();
        toast('Histórico com cliente deletado com sucesso.');
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingClientHistory(false);
    }
  }, []);

  // Interview
  const getInterviews = React.useCallback(async () => {
    try {
      setLoadingInterview(true);
      const { data, status, error } = await interviewCrud.read({
        id: Number(id),
      });

      if (error) throw new Error(error.message.description);

      if (status === 200 && data?.Interview) {
        setInterviews(data?.Interview)
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingInterview(false);
    }
  }, []);
  const handleDeleteInterview = React.useCallback(async (id: number) => {
    try {
      setLoadingInterview(true);
      const { data, status, error } = await interviewCrud.delete({
        id: id,
      });

      if (error) throw new Error(error.message.description);

      if (status === 200) {
        getInterviews();
        toast('Entrevista deletada com sucesso.');
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingInterview(false)
    }
  }, []);

  // Profissional Experience
  const getProfissionalExperience = React.useCallback(async () => {
    try {
      setLoadingProfEx(true);
      const { data, status, error } = await PECrud.read({
        personal_client_id: Number(id),
      });

      if (error) throw new Error(error.message.description);

      if (status === 200 && data?.ProfessionalExperience) {
        setProfEx(data?.ProfessionalExperience)
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingProfEx(false);
    }
  }, []);
  const handleDeleteProfissionalExperience = React.useCallback(async (id: number) => {
    try {
      setLoadingProfEx(true);
      const { data, status, error } = await PECrud.delete({
        id: id,
      });

      if (error) throw new Error(error.message.description);

      if (status === 200) {
        getProfissionalExperience();
        toast('Experiência deletada com sucesso.');
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingProfEx(false)
    }
  }, []);

  // Matchs
  const getMatchs = React.useCallback(async (page?: number) => {
      try {
        const { data, status, error } = await matchCrud.read({
          page,
          per_page: 3,
          personal_client_id: Number(id),
        });

        if (error) {
          throw new Error(error.message.description);
        }

        if (status === 200 && data) {
          setMatchs(data);
        }
      } catch (e) {
        alert(e);
      } finally {
        setTimeout(() => {}, 3000);
      }
  }, []);

  // Effect
  React.useEffect(() => {
    refreshData();
    getLanguages();
    getGraduations();
    getClientHistory();
    getInterviews();
    getMatchs();
    getProfissionalExperience()
  }, []);

  return (
    <Container>
      <MenuBar currentPage="Recolocação" />
      <Content>
        <Responsive>
          <Header>
            <HeaderBack href="/recolocacao-profissional">
              <BackFullIcon />
            </HeaderBack>
          </Header>
          {
            loading
            ?
              <LoadRow>
                <LoadingIndicator customStyle={{color: theme.colors.primary}} size='extraLarge'/>
              </LoadRow>
            :
              <ContainerCards>
                <CardsColumns maxWidth={380}>
                  <Card>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">Perfil</CardSectionTitle>
                    </CardSectionRow>
                    <Photo
                      src={
                        currentPersonalClient?.image || require('assets/images/user-temporary.webp')
                      }
                    />
                    <Name>{currentPersonalClient?.name}</Name>

                    <Occupation>{currentPersonalClient?.occupation}</Occupation>

                    <SelectsArea>
                      <ModalSelectContent>
                        <ModalValue
                          background={status?.color}
                          onClick={() => {
                            setShowStatusModal(true);
                          }}
                          textColor={status.textColor}>
                          {status?.title}
                          <ArrowIcon style={{ color: status.textColor }} />
                        </ModalValue>
                        {showStatusModal && (
                          <ModalSelect>
                            {STATUS?.map(el => (
                              <Select
                                onClick={() => {
                                  setStatus(el);
                                  handleUpdateClient(el.title);
                                  setShowStatusModal(false);
                                }}>
                                <SelectName key={el.id}>{el.title}</SelectName>
                              </Select>
                            ))}
                          </ModalSelect>
                        )}
                      </ModalSelectContent>
                    </SelectsArea>

                    <CardSeparator />

                    <CardSectionRow>
                      <CardSectionTitle size="normal">Detalhes</CardSectionTitle>

                      <ButtonComp onClick={() => navigate(`/editar-cliente-recolocacao/${id}`)}>
                        <EditIcon />
                      </ButtonComp>
                    </CardSectionRow>

                    <CardDescriptionTitle>Id da conta</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {currentPersonalClient?.id}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Email</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {currentPersonalClient?.email || '-'}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Telefone</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {formatarPhone(currentPersonalClient?.personal_phone || '') || '-'}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Endereço</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {currentPersonalClient?.local || '-'}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Cpf</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {formatCPF(currentPersonalClient?.cpf || '') || '-'}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Sexo</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {currentPersonalClient?.sexual_gender || '-'}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Estado civíl</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {currentPersonalClient?.marital_status || '-'}
                    </CardDescriptionLabel>

                    <CardDescriptionTitle>Número de filhos</CardDescriptionTitle>
                    <CardDescriptionLabel>
                      {currentPersonalClient?.number_children}
                    </CardDescriptionLabel>

                    {
                      (currentPersonalClient?.start_of_contract || currentPersonalClient?.end_of_contract) && (
                        <>
                          <CardDescriptionTitle>Tempo contrato</CardDescriptionTitle>
                          <CalendarTitleRow>
                            <CardDescriptionTitle style={{fontSize: 12, margin: 0}}>Inicio</CardDescriptionTitle>
                            <CardDescriptionTitle style={{fontSize: 12, margin: 0}}>Fim</CardDescriptionTitle>
                          </CalendarTitleRow>
                          <CalendarRow>
                            <CardDescriptionTitle>{currentPersonalClient?.start_of_contract ? currentPersonalClient?.start_of_contract : ' - '}</CardDescriptionTitle>
                            <ContainerIndicator>
                              <Circle />
                              <Line />
                              <Circle />
                            </ContainerIndicator>
                            <CardDescriptionTitle>{currentPersonalClient?.end_of_contract ? currentPersonalClient?.end_of_contract : ' - '}</CardDescriptionTitle>
                          </CalendarRow>
                        </>
                      )
                    }

                    <CardDescriptionTitle>Dados profissionais</CardDescriptionTitle>
                    {currentPersonalClient?.key_words &&
                      currentPersonalClient?.key_words?.length > 0 && (
                        <KeyWordsArea>
                          {currentPersonalClient?.key_words.map((e, i) => (
                            <KeyWord>{e}</KeyWord>
                          ))}
                        </KeyWordsArea>
                      )}
                  </Card>
                </CardsColumns>

                <CardsColumns >
                  <Card>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">
                        Profissional
                      </CardSectionTitle>

                      <ButtonComp onClick={() => navigate(`/editar-cliente-recolocacao/${id}`)}>
                        <EditIcon />
                      </ButtonComp>
                    </CardSectionRow>

                    <CardSectionRow style={{ marginBottom: 17 }}>
                      <CardSectionTitle size="normal">Detalhes</CardSectionTitle>

                      <CardSectionTitle size="normal">Recolocação</CardSectionTitle>
                    </CardSectionRow>

                    <CardSectionRow style={{ marginBottom: 17 }}>
                      <CardSectionColumn>
                        <CardDescriptionTitle>Ocupação</CardDescriptionTitle>
                        <CardDescriptionLabel style={{ marginBottom: 0 }}>
                          {currentPersonalClient?.occupation}
                        </CardDescriptionLabel>
                      </CardSectionColumn>

                      <CardSectionColumn>
                        <CardDescriptionTitle>Ocupação</CardDescriptionTitle>
                        <CardDescriptionLabel style={{ marginBottom: 0 }}>
                          {currentPersonalClient?.replacement_office}
                        </CardDescriptionLabel>
                      </CardSectionColumn>
                    </CardSectionRow>
                    <CardSectionRow style={{ marginBottom: 17 }}>
                      <CardSectionColumn>
                        <CardDescriptionTitle>Salário</CardDescriptionTitle>
                        <CardDescriptionLabel style={{ marginBottom: 0 }}>
                          R$ {currentPersonalClient?.budget}
                        </CardDescriptionLabel>
                      </CardSectionColumn>

                      <CardSectionColumn style={{ alignItems: 'flex-start' }}>
                        <CardDescriptionTitle>Empresa</CardDescriptionTitle>
                        <CardDescriptionLabel style={{ marginBottom: 0 }}>
                          {currentPersonalClient?.replacement_company}
                        </CardDescriptionLabel>
                      </CardSectionColumn>
                    </CardSectionRow>

                    <CardSectionRow style={{ marginBottom: 17 }}>
                      <CardSectionColumn>
                        <CardDescriptionTitle>Aceita mudar</CardDescriptionTitle>
                        <CardDescriptionLabel style={{ marginBottom: 0 }}>
                          {currentPersonalClient?.moving_conditions}
                        </CardDescriptionLabel>
                      </CardSectionColumn>

                      <CardSectionColumn style={{ alignItems: 'flex-start' }}>
                        <CardDescriptionTitle>Remuneração</CardDescriptionTitle>
                        <CardDescriptionLabel style={{ marginBottom: 0 }}>
                          {currentPersonalClient?.replacement_salary}
                        </CardDescriptionLabel>
                      </CardSectionColumn>
                    </CardSectionRow>
                  </Card>
                  <Card alternative>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">
                        Experiência Profissional
                      </CardSectionTitle>
                    </CardSectionRow>
                    <ClientHistoryContent>
                      {loadingProfEx ? (
                        <LoadRow>
                          <LoadingIndicator
                            customStyle={{
                              width: 40,
                              height: 40,
                              color: theme.colors.secondary,
                              marginBottom: 12,
                            }}
                            size="large"
                          />
                        </LoadRow>
                      ) : (
                        <>
                          {ProfEx?.map((e, i) => (
                            <ProfissionalCard key={i}>
                              <ProfessionalRow>
                                <ProfessionalTextBold>{e.company_name}</ProfessionalTextBold>
                                <ProfessionalIcons>
                                  <EditIconSmall onClick={() => {
                                    setCurrentProfEx(e);
                                    setShowModalProfEx(true);
                                  }}/>
                                  <TrashIconSmall onClick={() => handleDeleteProfissionalExperience(e.id)}/>
                                </ProfessionalIcons>
                              </ProfessionalRow>
                                <ProfessionalText style={{marginBottom: 8}}>{e.occupation_area} {e.level} | {e.role}</ProfessionalText>
                                <CardRowForSvg>
                                  <CalendarIcon/>
                                  <ProfessionalPeriod>{e.period}</ProfessionalPeriod>
                                </CardRowForSvg>
                            </ProfissionalCard>
                          ))}
                        </>
                      )}
                    </ClientHistoryContent>
                    <Button
                      title="Nova experiência"
                      callback={() => {
                        if (!showModalProfEx) setShowModalProfEx(e => !e);
                      }}
                    />
                  </Card>
                </CardsColumns>

                <CardsColumns minWidth={400}>
                  <Card>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">Idioma</CardSectionTitle>
                    </CardSectionRow>
                    {loadingLanguages ? (
                      <LoadRow>
                        <LoadingIndicator
                          customStyle={{
                            width: 40,
                            height: 40,
                            color: theme.colors.secondary,
                            marginBottom: 12,
                          }}
                          size="large"
                        />
                      </LoadRow>
                    ) : (
                      <>
                        {languages && languages.length > 0 ? (
                          languages?.map(e => (
                            <LanguageRow>
                              <Language>
                                {capitalizeFirstLetter(e.language_name)}
                              </Language>
                              <Language>
                                {capitalizeFirstLetter(e.language_level)}
                              </Language>
                              <ButtonComp
                                onClick={() => handleDeleteLanguage(e.id)}>
                                <TrashIcon />
                              </ButtonComp>
                            </LanguageRow>
                          ))
                        ) : (
                          <CardSectionTitle
                            style={{ marginBottom: 12 }}
                            size="normal">
                            Nenhum idioma cadastrado...
                          </CardSectionTitle>
                        )}
                      </>
                    )}
                    <Button
                      title="Novo Idioma"
                      callback={() => {
                        if (!showModalLanguage) setShowModalLanguage(e => !e);
                      }}
                    />
                  </Card>

                  <Card alternative>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">Formação</CardSectionTitle>
                    </CardSectionRow>
                    {loadingGraduation ? (
                      <LoadRow>
                        <LoadingIndicator
                          customStyle={{
                            width: 40,
                            height: 40,
                            color: theme.colors.secondary,
                            marginBottom: 12,
                          }}
                          size="large"
                        />
                      </LoadRow>
                    ) : (
                      <>
                        {graduation && graduation.length > 0 ? (
                          graduation?.map(e => (
                            <GraduationCard>
                              <GraduationRow>
                                <GraduationBold>
                                  {e.institution_name && `${e.institution_name} -`} {e.graduation_type}
                                </GraduationBold>
                                <GraduationIcons>
                                  <ButtonComp
                                    onClick={() => {
                                      setCurrentGraduation(e);
                                      setShowModalGraduation(true);
                                    }}>
                                    <EditIconSmall />
                                  </ButtonComp>
                                  <ButtonComp
                                    onClick={() => handleDeleteGraduations(e.id)}>
                                    <TrashIcon />
                                  </ButtonComp>
                                </GraduationIcons>
                              </GraduationRow>
                              <GraduationText style={{ marginTop: 0 }}>
                                {e.graduation_name} | {e.graduation_time}
                              </GraduationText>
                              <GraduationText>
                                {e.graduation_description}
                              </GraduationText>
                            </GraduationCard>
                          ))
                        ) : (
                          <CardSectionTitle
                            style={{ marginBottom: 12 }}
                            size="normal">
                            Nenhuma formação cadastrada...
                          </CardSectionTitle>
                        )}
                      </>
                    )}
                    <Button
                      callback={() => {
                        if (!showModalGraduation) setShowModalGraduation(true);
                      }}
                      title="Nova Formação"
                    />
                  </Card>

                  <Card alternative>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">Entrevistas</CardSectionTitle>
                    </CardSectionRow>
                    {loadingInterview ? (
                      <LoadRow>
                        <LoadingIndicator
                          customStyle={{
                            width: 40,
                            height: 40,
                            color: theme.colors.secondary,
                            marginBottom: 12,
                          }}
                          size="large"
                        />
                      </LoadRow>
                    ) : (
                      <>
                       <ClientHistoryContent>
                          {interviews && interviews.length > 0 ? (
                            interviews?.map(e => (
                              <InterviewCard key={e.id}>
                                <LanguageRow style={{ margin: 0 }}>
                                  <InterviewDataText>
                                    {e.created_at}
                                  </InterviewDataText>
                                  <GraduationIcons>
                                    <ButtonComp
                                      onClick={() => {
                                        setCurrentInterview(e)
                                        setShowModalInterview(true)
                                      }}>
                                      <EditIconSmall />
                                    </ButtonComp>
                                    <ButtonComp
                                      onClick={() => handleDeleteInterview(e.id)}>
                                      <TrashIcon />
                                    </ButtonComp>
                                  </GraduationIcons>
                                </LanguageRow>
                                <InterviewContent>
                                  <InterviewDescription>
                                    Empresa: 
                                  </InterviewDescription>
                                  <InterviewValue>{e.company}</InterviewValue>
                                </InterviewContent>
                                <InterviewContent>
                                  <InterviewDescription>
                                    Contato: 
                                  </InterviewDescription>
                                  <InterviewValue>{e.contact}</InterviewValue>
                                </InterviewContent>
                                <InterviewContent>
                                  <InterviewDescription>
                                    Vaga: 
                                  </InterviewDescription>
                                  <InterviewValue>{e.vacancy_name}</InterviewValue>
                                </InterviewContent>
                                <InterviewContent style={{marginBottom: 10}}>
                                  <InterviewDescription>
                                    Status: 
                                  </InterviewDescription>
                                  <InterviewValue>{e.status}</InterviewValue>
                                </InterviewContent>
                                <InterviewContent>
                                  <InterviewDescription>
                                    Feito por: 
                                  </InterviewDescription>
                                  <InterviewValue>{e.advisor_relation.advisor_name}</InterviewValue>
                                </InterviewContent>
                              </InterviewCard>
                            ))
                          ) : (
                            <CardSectionTitle
                              style={{ marginBottom: 12 }}
                              size="normal">
                              Nenhuma entrevista cadastrada...
                            </CardSectionTitle>
                          )}
                       </ClientHistoryContent>
                      </>
                    )}
                    <Button
                      callback={() => {
                        if (!showModalInterview) setShowModalInterview(true);
                      }}
                      title="Nova Entrevista"
                    />
                  </Card>
                </CardsColumns>

                <CardsColumns minWidth={381}>
                  <Card alternative>
                    {loadingClientHistory ? (
                      <LoadRow>
                        <LoadingIndicator
                          customStyle={{
                            width: 40,
                            height: 40,
                            color: theme.colors.secondary,
                            marginBottom: 12,
                          }}
                          size="large"
                        />
                      </LoadRow>
                    ) : (
                      <ClientHistoryContent>
                        {clientHistory && clientHistory?.length > 0 ? (
                          clientHistory?.map(e => (
                            <ClientHistoryCard>
                              <LanguageRow style={{ margin: 0 }}>
                                <ClientHistoryData>
                                  {transformarData(e.date)}
                                </ClientHistoryData>
                                <ButtonComp
                                  onClick={() => handleDeleteClientHistory(e.id)}>
                                  <TrashIcon />
                                </ButtonComp>
                              </LanguageRow>
                              {(() => {
                                const parsed = parseStructuredDescription(e.description);
                                if (parsed) {
                                  return (
                                    <>
                                      {parsed.headerText && (
                                        <ClientHistoryHeader>
                                          {parsed.headerText}
                                        </ClientHistoryHeader>
                                      )}
                                      {parsed.fields.map((field, i) => (
                                        <ClientHistoryFieldRow key={i}>
                                          <ClientHistoryFieldLabel>
                                            {field.label}
                                          </ClientHistoryFieldLabel>
                                          <ClientHistoryFieldValue>
                                            {field.value}
                                          </ClientHistoryFieldValue>
                                        </ClientHistoryFieldRow>
                                      ))}
                                    </>
                                  );
                                }
                                return (
                                  <ClientHistoryDescription>
                                    {e.description}
                                  </ClientHistoryDescription>
                                );
                              })()}
                            </ClientHistoryCard>
                          ))
                        ) : (
                          <CardSectionTitle
                            style={{ marginBottom: 12 }}
                            size="normal">
                            Nenhum evento cadastrado...
                          </CardSectionTitle>
                        )}
                      </ClientHistoryContent>
                    )}
                    <ClientHistoryButotn
                      title="Novo Evento"
                      callback={() => {
                        setShowModalClientHistory(e => !e);
                      }}
                    />
                  </Card>
                  <Card alternative maxHeight={390}>
                    <CardSectionRow>
                      <CardSectionTitle size="normal">Matchs : {currentPersonalClient?.vacancy_matching_quantity}</CardSectionTitle>
                      <SvgRow >
                        <CardSectionTitle size="normal" hasClick onClick={() => navigate(`/matchs/${currentPersonalClient?.id}`, {
                            state: { 
                              personalClient: {
                              name: currentPersonalClient?.name,
                              id: currentPersonalClient?.id,
                            }
                          },
                        })}>
                          Ver matchs
                        </CardSectionTitle>
                        <MatchIcon />
                      </SvgRow>
                    </CardSectionRow>
                      {matchs?.VacancyMatch?.map(e => (
                        <MatchCard>
                          <CardRow>
                            <MatchName>
                              {limitarString(e.vacancy_relation.vacancy_name, 38)}
                            </MatchName>
                            <MatchName>
                              {`Cod. `+ e.vacancy_relation.vacancy_id}
                            </MatchName>
                          </CardRow>
                          <MatchOccupation>{e.vacancy_relation.vacancy_occupation}</MatchOccupation>
                          <MatchName style={{marginTop: 12}}>{limitarString(e.vacancy_relation.vacancy_email, 40)}</MatchName>
                          <CardRow style={{marginTop: 20}}>
                            <CardRowForSvg>
                              <MoneyIcon />
                              <MatchMoney>{e.vacancy_relation.vacancy_budget ? e.vacancy_relation.vacancy_budget : '-'}</MatchMoney>
                            </CardRowForSvg>
                            <CardRowForSvg>
                              <PinIcon />
                              <MatchLocal>{e.vacancy_relation.vacancy_local ? e.vacancy_relation.vacancy_local : '-'}</MatchLocal>
                            </CardRowForSvg>
                          </CardRow>
                        </MatchCard>
                      ))}
                  </Card>
                </CardsColumns>
              </ContainerCards>
          }
        </Responsive>
      </Content>
      {showModalLanguage && (
        <LanguageModal
          onClose={() => {
            getLanguages();
            setShowModalLanguage(false);
          }}
          vacancyId={currentPersonalClient?.id}
          isVacancy={false}
        />
      )}
      {showModalGraduation && (
        <GraduationModal
          onClose={() => {
            setCurrentGraduation(undefined);
            getGraduations();
            setShowModalGraduation(false);
          }}
          graduationId={currentPersonalClient?.id}
          graduation={currentGraduation}
          isVacancy={false}
        />
      )}
      {showModalInterview && (
        <InterviewModal
          data={currentInterview}
          onClose={() => {
           setShowModalInterview(false)
           setCurrentInterview(undefined)
           getInterviews()
          }}
          personalClientId={Number(id) || 1}
        />
      )}
      {showModalClientHistory && (
        <ClientHistoryModal
          personalClientId={Number(id) || 0}
          onClose={() => {
            setShowModalClientHistory(false);
            getClientHistory();
          }}
        />
      )}
      {showModalProfEx && (
        <ProfissionalExperienceModal
          data={currentProfEx}
          id={Number(id) || 0}
          onClose={() => {
            getProfissionalExperience()
            setShowModalProfEx(false);
          }}
        />
      )}
    </Container>
  );
};

export default VisualizatePersonalClient;

const STATUS = [
  {
    id: 0,
    color: '#FF565685',
    textColor: '#7C0A0A',
    title: 'Atuando/Trabalhando',
  },
  {
    id: 1,
    color: '#ABDBCA',
    textColor: '#316F59',
    title: 'Disponível',
  },
];